/* NETWRK theme — interactions + AJAX cart */
(function(){
/* ---- interactive network background ---- */
var c=document.getElementById('net');
if(c){
  var ctx=c.getContext('2d');
  var reduce=matchMedia('(prefers-reduced-motion:reduce)').matches;
  var w=0,h=0,dpr=1,parts=[];var mouse={x:-9999,y:-9999,active:false};
  var LINK=132,MOUSE=210;
  function build(){
    dpr=Math.min(window.devicePixelRatio||1,2);w=innerWidth;h=innerHeight;
    c.width=w*dpr;c.height=h*dpr;c.style.width=w+'px';c.style.height=h+'px';
    ctx.setTransform(dpr,0,0,dpr,0,0);
    var target=Math.max(36,Math.min(130,Math.floor(w*h/11000)));parts=[];
    for(var i=0;i<target;i++){parts.push({x:Math.random()*w,y:Math.random()*h,vx:(Math.random()-.5)*.34,vy:(Math.random()-.5)*.34});}
  }
  addEventListener('resize',build);
  addEventListener('mousemove',function(e){mouse.x=e.clientX;mouse.y=e.clientY;mouse.active=true;});
  addEventListener('mouseout',function(){mouse.active=false;mouse.x=mouse.y=-9999;});
  function frame(){
    ctx.clearRect(0,0,w,h);
    for(var k=0;k<parts.length;k++){var p=parts[k];
      if(!reduce){p.x+=p.vx;p.y+=p.vy;if(p.x<-20)p.x=w+20;else if(p.x>w+20)p.x=-20;if(p.y<-20)p.y=h+20;else if(p.y>h+20)p.y=-20;}
      if(mouse.active){var dx=p.x-mouse.x,dy=p.y-mouse.y,d=Math.hypot(dx,dy);if(d<MOUSE&&d>0.01){var f=(MOUSE-d)/MOUSE*0.7;p.x+=dx/d*f;p.y+=dy/d*f;}}
    }
    for(var i=0;i<parts.length;i++){var a=parts[i];
      for(var j=i+1;j<parts.length;j++){var b=parts[j],dx2=a.x-b.x,dy2=a.y-b.y,d2=Math.hypot(dx2,dy2);
        if(d2<LINK){ctx.strokeStyle='rgba(17,17,20,'+((1-d2/LINK)*0.20)+')';ctx.lineWidth=1;ctx.beginPath();ctx.moveTo(a.x,a.y);ctx.lineTo(b.x,b.y);ctx.stroke();}}
      var dxm=a.x-mouse.x,dym=a.y-mouse.y,dm=Math.hypot(dxm,dym),near=mouse.active&&dm<MOUSE;
      if(near){ctx.strokeStyle='rgba(46,91,255,'+((1-dm/MOUSE)*0.55)+')';ctx.lineWidth=1;ctx.beginPath();ctx.moveTo(a.x,a.y);ctx.lineTo(mouse.x,mouse.y);ctx.stroke();}
      ctx.fillStyle=near?'rgba(46,91,255,'+(0.45+(1-dm/MOUSE)*0.5)+')':'rgba(17,17,20,0.5)';
      ctx.beginPath();ctx.arc(a.x,a.y,near?2.3:1.5,0,6.3);ctx.fill();
    }
    requestAnimationFrame(frame);
  }
  build();frame();
}

/* ---- cursor ---- */
var dot=document.getElementById('cDot'),glow=document.getElementById('cGlow');
if(dot&&glow){var mx=innerWidth/2,my=innerHeight/2,gx=mx,gy=my;
  addEventListener('mousemove',function(e){mx=e.clientX;my=e.clientY;dot.style.left=mx+'px';dot.style.top=my+'px';});
  (function loop(){gx+=(mx-gx)*.12;gy+=(my-gy)*.12;glow.style.left=gx+'px';glow.style.top=gy+'px';requestAnimationFrame(loop);})();
}

/* ---- loader ---- */
var loader=document.getElementById('loader');
if(loader){window.addEventListener('load',function(){setTimeout(function(){loader.classList.add('done');},1500);});}

/* ---- header scroll ---- */
var header=document.getElementById('header');
if(header){addEventListener('scroll',function(){header.classList.toggle('scrolled',scrollY>40);});}

/* ---- menu ---- */
var burger=document.getElementById('burger'),menu=document.getElementById('menu'),scrim=document.getElementById('scrim');
function toggleMenu(open){if(!menu)return;burger.classList.toggle('open',open);menu.classList.toggle('open',open);scrim.classList.toggle('open',open);}
if(burger){burger.addEventListener('click',function(){toggleMenu(!menu.classList.contains('open'));});}
if(scrim){scrim.addEventListener('click',function(){toggleMenu(false);});}
if(menu){[].forEach.call(menu.querySelectorAll('a'),function(a){a.addEventListener('click',function(){toggleMenu(false);});});}

/* ---- magnetic buttons ---- */
[].forEach.call(document.querySelectorAll('[data-mag]'),function(el){
  el.addEventListener('mousemove',function(e){var r=el.getBoundingClientRect();var x=e.clientX-r.left-r.width/2,y=e.clientY-r.top-r.height/2;el.style.transform='translate('+(x*.25)+'px,'+(y*.35)+'px)';});
  el.addEventListener('mouseleave',function(){el.style.transform='';});
});

/* ---- hero parallax ---- */
var hp=document.getElementById('heroParallax');
if(hp){addEventListener('scroll',function(){var y=scrollY;if(y<innerHeight){hp.style.transform='translateY('+(y*.08)+'px)';hp.style.opacity=1-y/(innerHeight*.9);}});}

/* ---- reveal on scroll ---- */
var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:.12});
[].forEach.call(document.querySelectorAll('.reveal'),function(el){io.observe(el);});

/* ============================================================
   AJAX CART (Shopify Cart API)
   ============================================================ */
var money=window.NETWRK&&window.NETWRK.moneyFormat?window.NETWRK.moneyFormat:'${{amount}}';
function fmt(cents){
  var v=(cents/100),s=money;
  function n(x,dec){dec=dec==null?2:dec;var f=(x).toFixed(dec).split('.');f[0]=f[0].replace(/\B(?=(\d{3})+(?!\d))/g,',');return dec?f.join('.'):f[0];}
  return s.replace(/\{\{\s*amount\s*\}\}/g,n(v,2)).replace(/\{\{\s*amount_no_decimals\s*\}\}/g,n(v,0)).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g,n(v,2));
}
var drawer=document.getElementById('cartDrawer'),cartScrim=document.getElementById('cartScrim'),
    cartItems=document.getElementById('cartItems'),cartCount=document.getElementById('cartCount'),
    cartSubtotal=document.getElementById('cartSubtotal');
function openCart(o){if(!drawer)return;drawer.classList.toggle('open',o);cartScrim.classList.toggle('open',o);}
var ct=document.getElementById('cartToggle');if(ct)ct.addEventListener('click',function(){openCart(true);getCart();});
var cc=document.getElementById('cartClose');if(cc)cc.addEventListener('click',function(){openCart(false);});
if(cartScrim)cartScrim.addEventListener('click',function(){openCart(false);});
addEventListener('keydown',function(e){if(e.key==='Escape'){openCart(false);toggleMenu(false);}});

function render(cart){
  if(cartCount)cartCount.textContent=cart.item_count;
  if(cartSubtotal)cartSubtotal.textContent=fmt(cart.total_price);
  if(!cartItems)return;
  if(!cart.items.length){cartItems.innerHTML='<div class="cart-empty">Your cart is empty</div>';return;}
  cartItems.innerHTML=cart.items.map(function(it){
    var img=it.image?it.image:'';
    return '<div class="ci" data-key="'+it.key+'">'+
      '<div class="ci-img" style="background-image:url('+img+')"></div>'+
      '<div class="ci-info"><b>'+it.product_title+'</b>'+
      (it.variant_title&&it.variant_title!=='Default Title'?'<div class="ci-price">'+it.variant_title+'</div>':'')+
      '<div class="ci-price">'+fmt(it.final_price)+'</div>'+
      '<div class="ci-qty"><button data-key="'+it.key+'" data-q="'+(it.quantity-1)+'">&minus;</button><span>'+it.quantity+'</span><button data-key="'+it.key+'" data-q="'+(it.quantity+1)+'">+</button></div>'+
      '<button class="ci-remove" data-key="'+it.key+'" data-q="0">Remove</button></div></div>';
  }).join('');
}
function getCart(){fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(render);}
function bump(){if(cartCount){cartCount.classList.add('bump');setTimeout(function(){cartCount.classList.remove('bump');},300);}}

document.addEventListener('click',function(e){
  var add=e.target.closest?e.target.closest('.add[data-variant-id]'):null;
  if(add){e.preventDefault();
    var id=add.getAttribute('data-variant-id');
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:id,quantity:1})})
      .then(function(r){return r.json();}).then(function(){getCart();bump();openCart(true);});
    return;
  }
  var q=e.target.closest?e.target.closest('.ci-qty button,.ci-remove'):null;
  if(q){var key=q.getAttribute('data-key'),qty=q.getAttribute('data-q');
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:parseInt(qty,10)})})
      .then(function(r){return r.json();}).then(render);
  }
});
getCart();

/* ---- smooth in-page anchor scrolling (prevents reload on #links) ---- */
document.addEventListener('click',function(e){
  var a=e.target.closest?e.target.closest('a[href^="#"]'):null;
  if(!a)return;
  var id=a.getAttribute('href');
  if(id==='#'){e.preventDefault();return;}
  var t=document.querySelector(id);
  if(t){e.preventDefault();var y=t.getBoundingClientRect().top+window.pageYOffset-70;window.scrollTo({top:y,behavior:'smooth'});}
});

/* ---- entry promo popup ---- */
(function(){
  var pop=document.getElementById('promo');if(!pop)return;
  var scr=document.getElementById('promoScrim'),KEY='netwrk_promo_seen',seen=false;
  try{seen=localStorage.getItem(KEY)==='1';}catch(err){}
  function open(){scr.classList.add('open');pop.classList.add('open');try{localStorage.setItem(KEY,'1');}catch(err){}}
  function close(){scr.classList.remove('open');pop.classList.remove('open');}
  if(!seen){var d=parseFloat(pop.getAttribute('data-delay')||'2.5')*1000;setTimeout(open,d);}
  var x=document.getElementById('promoClose');if(x)x.onclick=close;
  var no=document.getElementById('promoNo');if(no)no.onclick=function(e){e.preventDefault();close();};
  if(scr)scr.onclick=close;
  addEventListener('keydown',function(e){if(e.key==='Escape')close();});
  var sub=document.getElementById('promoSubmit');
  if(sub)sub.onclick=function(){
    var el=document.getElementById('promoPhone'),v=(el.value||'').replace(/\D/g,'');
    if(v.length<10){el.style.borderColor='#ff6b6b';return;}
    document.getElementById('promoForm').style.display='none';
    document.getElementById('promoDone').style.display='block';
  };
})();
})();

/* ---- button press animation (tactile click feedback) ---- */
(function(){
  document.addEventListener('pointerdown',function(e){
    var b=e.target.closest?e.target.closest('.btn,.add,.social-btn,.cart-toggle,.cart-close,.promo-close,.ci-qty button,.ci-remove'):null;
    if(!b)return;
    b.classList.remove('pressing');void b.offsetWidth;b.classList.add('pressing');
  },true);
  document.addEventListener('animationend',function(e){
    if(e.target&&e.target.classList&&e.target.classList.contains('pressing'))e.target.classList.remove('pressing');
  });
})();
